// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HX17","title":"styles_title__3YNLq"};